<template>
  <!-- 释放库存审批 -->
  <releaseitory-check
    :sna-id="snaId"
    :data.sync="checkDataInfo"
  >
    <template v-slot:footer>
      <check-module
        :title="`审批`"
      >
        <check-handle-module
          :checkFromData.sync="checkFromData"
          :pass-dialog-txt="`审批通过后将释放库存。`"
          @submitCheck="submitCheck"
        ></check-handle-module>
      </check-module>
    </template>
  </releaseitory-check>
</template>

<script>
import releaseitoryCheck from '@/views/workbench/workCheckManage/releaseitoryCheck/releaseitoryCheck'
import releaseitoryCheckApi from '@/api/workbench/check'

import checkMixin from '@/mixin/checkMixin'

export default {
  name: 'releaseitoryCheckView',
  components: {
    releaseitoryCheck
  },
  mixins: [checkMixin],
  data () {
    return {
      checkDetailName: 'releaseitorycheckdetail'
    }
  },
  methods: {
    submitCheck (form) {
      const checkData = this.formatCheckParams(form)
      releaseitoryCheckApi.submitReleaseitoryCheckInfo(checkData)
        .then(res => {
          this.goCheckDetail(res)
        })
    }
  }
}
</script>

<style scoped>

</style>
